import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import {
    ROUTE_APPOINTMENTS_SETTINGS,
} from '../../../../config/routes';
import { history, store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';

function SettingsAppointments(props) {

  return (
    <Fragment>
      <Button
        className="btn-warning"
        color="primary"
        onClick={() => {
         store.dispatch(hideNotification());
         history.push(ROUTE_APPOINTMENTS_SETTINGS);
        }}
        size="sm"
      >
        <FormattedMessage
          id="components.pages.appointments.actionButtons.settings_appointments" />
      </Button>
    </Fragment>
  )
}

export { SettingsAppointments };
